module.exports = "https://static.wanderu.com/static/media/logo.a177a428.png";